import { Route, Routes } from "react-router-dom";
import Index from "./pages/Index";
import ContactUs from "./pages/ContactUs";
import AboutUs from "./pages/AboutUs";
import React from "react";
// import TravelGuides from "./pages/TravelGuides";
import GuideDetail from "./pages/GuideDetail";
import CulturalFestivals from "./pages/CulturalFestivals";
import FestivalDetail from "./pages/FestivalDetail";
import HistoricalTours from "./pages/HistoricalTours";
import HistoricalTourDetail from "./pages/HistoricalTourDetail";
import WildlifeSafaris from "./pages/WildlifeSafaris";
import SafariDetail from "./pages/SafariDetail";
import Faqs from "./pages/Faqs";
import DigiCenter from "./pages/DigiCenter";
// import Booking from "./pages/Booking";
import VirtualTour from "./pages/VirtualTour";
import PolicyTerms from "./pages/PolicyTerms";
// import MaintenancePage from "./pages/MaintenancePage";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Index />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/about-us" element={<AboutUs />} />
      {/* <Route path="/travel-guides" element={<TravelGuides />} /> */}
      <Route path="/guide-detail/:id" element={<GuideDetail />} />
      <Route path="/cultural-festivals" element={<CulturalFestivals />} />
      <Route path="/festival-detail/:id" element={<FestivalDetail />} />
      <Route path="/historical-tours" element={<HistoricalTours />} />
      <Route path="/historical-tour-detail/:id" element={<HistoricalTourDetail />} />
      <Route path="/wildlife-safaris" element={<WildlifeSafaris />} />
      <Route path="/safari-detail/:id" element={<SafariDetail />} />
      <Route path="/faqs" element={<Faqs />} />
      <Route path="/digital-space" element={<DigiCenter />} />
      {/* <Route path="/booking" element={<Booking />} /> */}
        <Route path="/virtual-tour" element={<VirtualTour />} />
        <Route path="/policy-terms" element={<PolicyTerms />} />
        {/* <Route path="/" element={<MaintenancePage />} /> */}
        {/* Error page */}
        <Route path="*" element={
          <div
            className='Error flex flex-col items-center justify-center text-center gap-8 w-full min-h-screen px-4 sm:px-16 md:px-32 lg:px-80 mx-auto'
            style={{
              backgroundImage: 'radial-gradient(gray 0px, transparent 1px)',
              backgroundSize: '20px 20px'
            }}
          >
            <div>
              <img src='../assets/404error.png' alt='404 error' className='w-16 h-16 mx-auto' />
            </div>
            <div className='text-3xl sm:text-4xl md:text-6xl font-semibold tracking-tighter capitalize'>
              <h2>oops 404 again! sorry, page not found.</h2>
            </div>
            <div className='font-roboto-mono'>
              <p className='-tracking-tighter lg:px-24 mx-auto'>Looks like nothing was found in this location. Check the url path entered or maybe try a search... </p>
            </div>
          </div>
        } />
      </Routes>
    </>
  );
}

export default App;
